export const SET_CATEGORIES = "SET_CATEGORIES";
export const SET_CATEGORIES_ERROR = "SET_CATEGORIES_ERROR";
export const SET_CATEGORIES_LOADING = "SET_CATEGORIES_LOADING";
export const SET_CREATED_CATEGORY = "SET_CREATED_CATEGORY";
export const SET_UPDATED_CATEGORY = "SET_UPDATED_CATEGORY";
export const REMOVE_DELETED_CATEGORY = "REMOVE_DELETED_CATEGORY";
export const SET_CATEGORIES_FETCHING = "SET_CATEGORIES_FETCHING";
